/* eslint-disable react-refresh/only-export-components */
import { lazy } from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'
import { AppLayout } from '@/layouts/AppLayout'
import { RequireAnon, RequireAuth } from '@/auth/RequireAuth'
import { RequireAdmin } from '@/auth/RequireAdmin'

// Все защищённые страницы лениво — bundle splitting.
const DashboardPage = lazy(() =>
  import('@/pages/DashboardPage').then((m) => ({ default: m.DashboardPage })),
)
const LibraryPage = lazy(() =>
  import('@/pages/LibraryPage').then((m) => ({ default: m.LibraryPage })),
)
const SubscriptionsPage = lazy(() =>
  import('@/pages/SubscriptionsPage').then((m) => ({ default: m.SubscriptionsPage })),
)
const SettingsFeedPage = lazy(() =>
  import('@/pages/SettingsFeedPage').then((m) => ({ default: m.SettingsFeedPage })),
)
const SettingsTokensPage = lazy(() =>
  import('@/pages/SettingsTokensPage').then((m) => ({ default: m.SettingsTokensPage })),
)
const SettingsCookiesPage = lazy(() =>
  import('@/pages/SettingsCookiesPage').then((m) => ({ default: m.SettingsCookiesPage })),
)
const SettingsSecurityPage = lazy(() =>
  import('@/pages/SettingsSecurityPage').then((m) => ({ default: m.SettingsSecurityPage })),
)

// Auth-страницы тоже ленивые — на главном пути они не нужны.
const LoginPage = lazy(() => import('@/pages/LoginPage').then((m) => ({ default: m.LoginPage })))
const RegisterPage = lazy(() =>
  import('@/pages/RegisterPage').then((m) => ({ default: m.RegisterPage })),
)
const RecoveryPage = lazy(() =>
  import('@/pages/RecoveryPage').then((m) => ({ default: m.RecoveryPage })),
)
const NotFoundPage = lazy(() =>
  import('@/pages/NotFoundPage').then((m) => ({ default: m.NotFoundPage })),
)
const AdminRolesPage = lazy(() =>
  import('@/pages/AdminRolesPage').then((m) => ({ default: m.AdminRolesPage })),
)
const AdminUsersPage = lazy(() =>
  import('@/pages/AdminUsersPage').then((m) => ({ default: m.AdminUsersPage })),
)
const AdminUserLibraryPage = lazy(() =>
  import('@/pages/AdminUserLibraryPage').then((m) => ({ default: m.AdminUserLibraryPage })),
)

export const router = createBrowserRouter([
  {
    element: <RequireAnon />,
    children: [
      { path: '/login', element: <LoginPage /> },
      { path: '/register', element: <RegisterPage /> },
      { path: '/recovery', element: <RecoveryPage /> },
    ],
  },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { path: '/', element: <DashboardPage /> },
          { path: '/library', element: <LibraryPage /> },
          { path: '/subscriptions', element: <SubscriptionsPage /> },
          { path: '/settings/feed', element: <SettingsFeedPage /> },
          { path: '/settings/tokens', element: <SettingsTokensPage /> },
          { path: '/settings/cookies', element: <SettingsCookiesPage /> },
          { path: '/settings/security', element: <SettingsSecurityPage /> },
          { path: '/settings', element: <Navigate to="/settings/feed" replace /> },
          {
            element: <RequireAdmin />,
            children: [
              { path: '/admin/users', element: <AdminUsersPage /> },
              { path: '/admin/users/:userId', element: <AdminUserLibraryPage /> },
              { path: '/admin/invites', element: <Navigate to="/admin/users" replace /> },
              { path: '/admin/roles', element: <AdminRolesPage /> },
              { path: '/admin', element: <Navigate to="/admin/users" replace /> },
            ],
          },
        ],
      },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
])
